import React from "react";
import { doc, setDoc, serverTimestamp, Timestamp } from "firebase/firestore";
import { db } from "../../firebase/FirebaseCredential";

import BenchHeading from "./UI/BenchHeading";
import { NeonBadge, BenchTable } from "./UI";
import RateCard from "./UI/RateCard";
import CapacityGaugeCard from "./UI/CapacityGaugeCard";
import ProfitChart, { ChartDataItem } from "./UI/ProfitChart";
import BenchPaper from "./UI/BenchPaper";
import BenchStatusSelect from "./UI/BenchStatusSelect";
import { Button } from "@mantine/core";

export default function UIViewPage() {

  // async function saveAttendanceMetricsClient(adminId: string, companyId: string, uid: string, attendanceData: any) {
  //   try {
  //     const docId = "11-2025"; // month-year document ID
  //     const monthYearNum = 202511;

  //     const metricsRef = doc(
  //       db,
  //       "admin",
  //       adminId,
  //       "attendancemetrics",
  //       docId
  //     );

  //     const payload = {
  //       admin_id: adminId,
  //       company_id: companyId,
  //       uid,
  //       month_year_num: monthYearNum,
  //       updated_at: serverTimestamp(),
  //       ...attendanceData, // spread dates
  //     };

  //     await setDoc(metricsRef, payload, { merge: true });

  //     return { success: true };
  //   } catch (error) {
  //     console.error("Save attendance error:", error);
  //     return { success: false, error };
  //   }
  // }

  // const handleUpload = async () => {
  //   await saveAttendanceMetricsClient(
  //     "H7Xj2u44vY0HwEIuoHcP",
  //     "hectqUUXzkDkQL6Ob3Md",
  //     "",
  //     novemberAttendance
  //   );
  // };

  return (
    <div style={{ padding: "20px" }}>
      <BenchHeading
        title="H1 Heading"
        subheading="This is a subheading example"
        order={1}
      />

      <NeonBadge text={"skjdiosdjio"} />
      <RateCard
        title="Member Retention"
        subtitle="Returning members this month"
        percentage={55}
        change={5}
      />

      <CapacityGaugeCard />
      <ProfitChart
        data={customData}
        title="Monthly Profit"
        subtitle="Net income after expense"
        percentage={82}
        colors={['#e9da34ff']}
      />
      <BenchPaper title="Dashboard" width="80%">
        <p>This is inside the reusable BenchPaper component.</p>
      </BenchPaper>
      {/* <BenchStatusSelect
      items={statuses}
      activeIndex={3}
      onChange={(i) => console.log("Selected index:", i)}
      width="850"
      /> */}
      {/* <Button onClick={handleUpload}>upload attendance</Button> */}
    </div>
  );
}
const customData: ChartDataItem[] = [
  { month: 'Jan', value: 80 },
  { month: 'Feb', value: 95 },
  { month: 'Mar', value: 60 },
  { month: 'Apr', value: 85 },
  { month: 'May', value: 70 },
  { month: 'Jun', value: 90 },
  { month: 'Jul', value: 75 }
];

// const novemberAttendance = {
//   admin_id: "H7Xj2u44vY0HwEIuoHcP",
//   company_id: "hectqUUXzkDkQL6Ob3Md",
//   month_year_num: 202511,
//   uid: "",

//   "01/11/2025": {
//     first_checkin: null,
//     last_checkout: null,
//     in_hours: 0,
//     status: "W"
//   },

//   "02/11/2025": {
//     first_checkin: null,
//     last_checkout: null,
//     in_hours: 0,
//     status: "W"
//   },

//   "03/11/2025": {
//     first_checkin: Timestamp.fromDate(new Date("2025-11-03T10:00:00+05:30")),
//     last_checkout: Timestamp.fromDate(new Date("2025-11-03T18:00:00+05:30")),
//     in_hours: 8,
//     status: "P"
//   },

//   "04/11/2025": {
//     first_checkin: Timestamp.fromDate(new Date("2025-11-04T10:00:00+05:30")),
//     last_checkout: Timestamp.fromDate(new Date("2025-11-04T18:00:00+05:30")),
//     in_hours: 8,
//     status: "P"
//   },

//   "05/11/2025": {
//     first_checkin: Timestamp.fromDate(new Date("2025-11-05T10:00:00+05:30")),
//     last_checkout: Timestamp.fromDate(new Date("2025-11-05T18:00:00+05:30")),
//     in_hours: 8,
//     status: "P"
//   },

//   "06/11/2025": {
//     first_checkin: Timestamp.fromDate(new Date("2025-11-06T10:00:00+05:30")),
//     last_checkout: Timestamp.fromDate(new Date("2025-11-06T18:00:00+05:30")),
//     in_hours: 8,
//     status: "P"
//   },

//   "07/11/2025": {
//     first_checkin: Timestamp.fromDate(new Date("2025-11-07T10:00:00+05:30")),
//     last_checkout: Timestamp.fromDate(new Date("2025-11-07T18:00:00+05:30")),
//     in_hours: 8,
//     status: "P"
//   },

//   "08/11/2025": {
//     first_checkin: null,
//     last_checkout: null,
//     in_hours: 0,
//     status: "W"
//   },

//   "09/11/2025": {
//     first_checkin: null,
//     last_checkout: null,
//     in_hours: 0,
//     status: "W"
//   },

//   "10/11/2025": {
//     first_checkin: Timestamp.fromDate(new Date("2025-11-10T10:00:00+05:30")),
//     last_checkout: Timestamp.fromDate(new Date("2025-11-10T18:00:00+05:30")),
//     in_hours: 8,
//     status: "P"
//   },

//   "11/11/2025": {
//     first_checkin: Timestamp.fromDate(new Date("2025-11-11T10:00:00+05:30")),
//     last_checkout: Timestamp.fromDate(new Date("2025-11-11T18:00:00+05:30")),
//     in_hours: 8,
//     status: "P"
//   },

//   "12/11/2025": {
//     first_checkin: Timestamp.fromDate(new Date("2025-11-12T10:00:00+05:30")),
//     last_checkout: Timestamp.fromDate(new Date("2025-11-12T18:00:00+05:30")),
//     in_hours: 8,
//     status: "P"
//   },

//   "13/11/2025": {
//     first_checkin: Timestamp.fromDate(new Date("2025-11-13T10:00:00+05:30")),
//     last_checkout: Timestamp.fromDate(new Date("2025-11-13T18:00:00+05:30")),
//     in_hours: 8,
//     status: "P"
//   },

//   "14/11/2025": {
//     first_checkin: Timestamp.fromDate(new Date("2025-11-14T10:00:00+05:30")),
//     last_checkout: Timestamp.fromDate(new Date("2025-11-14T18:00:00+05:30")),
//     in_hours: 8,
//     status: "P"
//   },

//   "15/11/2025": {
//     first_checkin: Timestamp.fromDate(new Date("2025-11-15T14:46:43+05:30")),
//     last_checkout: Timestamp.fromDate(new Date("2025-11-15T14:46:56+05:30")),
//     in_hours: 8,
//     status: "W"
//   },

//   "16/11/2025": {
//     first_checkin: Timestamp.fromDate(new Date("2025-11-16T10:00:00+05:30")),
//     last_checkout: Timestamp.fromDate(new Date("2025-11-16T18:00:00+05:30")),
//     in_hours: 8,
//     status: "P"
//   },

//   "17/11/2025": {
//     first_checkin: Timestamp.fromDate(new Date("2025-11-17T10:00:00+05:30")),
//     last_checkout: Timestamp.fromDate(new Date("2025-11-17T18:00:00+05:30")),
//     in_hours: 8,
//     status: "P"
//   },

//   "18/11/2025": {
//     first_checkin: Timestamp.fromDate(new Date("2025-11-18T10:00:00+05:30")),
//     last_checkout: Timestamp.fromDate(new Date("2025-11-18T18:00:00+05:30")),
//     in_hours: 8,
//     status: "P"
//   },

//   "19/11/2025": {
//     first_checkin: Timestamp.fromDate(new Date("2025-11-19T10:00:00+05:30")),
//     last_checkout: Timestamp.fromDate(new Date("2025-11-19T18:00:00+05:30")),
//     in_hours: 8,
//     status: "P"
//   },

//   "20/11/2025": {
//     first_checkin: Timestamp.fromDate(new Date("2025-11-20T10:00:00+05:30")),
//     last_checkout: Timestamp.fromDate(new Date("2025-11-20T18:00:00+05:30")),
//     in_hours: 8,
//     status: "P"
//   },

//   "21/11/2025": {
//     first_checkin: Timestamp.fromDate(new Date("2025-11-21T10:00:00+05:30")),
//     last_checkout: Timestamp.fromDate(new Date("2025-11-21T18:00:00+05:30")),
//     in_hours: 8,
//     status: "P"
//   },

//   "22/11/2025": {
//     first_checkin: Timestamp.fromDate(new Date("2025-11-22T10:00:00+05:30")),
//     last_checkout: Timestamp.fromDate(new Date("2025-11-22T18:00:00+05:30")),
//     in_hours: 8,
//     status: "P"
//   },

//   "23/11/2025": {
//     first_checkin: Timestamp.fromDate(new Date("2025-11-23T10:00:00+05:30")),
//     last_checkout: Timestamp.fromDate(new Date("2025-11-23T18:00:00+05:30")),
//     in_hours: 8,
//     status: "P"
//   },

//   "24/11/2025": {
//     first_checkin: Timestamp.fromDate(new Date("2025-11-24T10:00:00+05:30")),
//     last_checkout: Timestamp.fromDate(new Date("2025-11-24T18:00:00+05:30")),
//     in_hours: 8,
//     status: "P"
//   },

//   "25/11/2025": {
//     first_checkin: Timestamp.fromDate(new Date("2025-11-25T10:00:00+05:30")),
//     last_checkout: Timestamp.fromDate(new Date("2025-11-25T18:00:00+05:30")),
//     in_hours: 8,
//     status: "P"
//   },

//   "26/11/2025": {
//     first_checkin: Timestamp.fromDate(new Date("2025-11-26T10:00:00+05:30")),
//     last_checkout: Timestamp.fromDate(new Date("2025-11-26T18:00:00+05:30")),
//     in_hours: 8,
//     status: "P"
//   },

//   "27/11/2025": {
//     first_checkin: Timestamp.fromDate(new Date("2025-11-27T10:00:00+05:30")),
//     last_checkout: Timestamp.fromDate(new Date("2025-11-27T18:00:00+05:30")),
//     in_hours: 8,
//     status: "P"
//   },

//   "28/11/2025": {
//     first_checkin: Timestamp.fromDate(new Date("2025-11-28T10:00:00+05:30")),
//     last_checkout: Timestamp.fromDate(new Date("2025-11-28T18:00:00+05:30")),
//     in_hours: 8,
//     status: "P"
//   },

//   "29/11/2025": {
//     first_checkin: Timestamp.fromDate(new Date("2025-11-29T10:00:00+05:30")),
//     last_checkout: Timestamp.fromDate(new Date("2025-11-29T18:00:00+05:30")),
//     in_hours: 8,
//     status: "P"
//   },

//   "30/11/2025": {
//     first_checkin: Timestamp.fromDate(new Date("2025-11-30T10:00:00+05:30")),
//     last_checkout: Timestamp.fromDate(new Date("2025-11-30T18:00:00+05:30")),
//     in_hours: 8,
//     status: "P"
//   }
// }
